import styles from '../styles/survey.module.css';


const SecondQuestion = ({ questionTitle, answers, onQuestionPress, dataId }) => {

  const questionPress = (id, answer) => {
    onQuestionPress(id, answer);
  }

  return (
    <div className={styles.secSurveyContainer}>
      <p className={styles.secQuestionTitle}>{questionTitle}</p>
      {
        answers?.map((answer, index) => (
          <div key={index} className={styles.secSurveyQuestion} onClick={() => questionPress(dataId, answer)}>
            <p className={styles.secQuestionDescription}>{answer}</p>
          </div>
        ))
      }
    </div>
  )
}

export default SecondQuestion;